import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';

/** Zusatz hinter jedem Seitentitel — entspricht dem Titel in der index.html. */
const BRAND = 'AWO Care';

/**
 * Setzt den Browser-Titel bei jedem Routenwechsel aus dem Seitennamen der
 * Route, damit Tab und Screenreader-Ansage sagen, wo man ist (WCAG 2.4.2,
 * #1012). Ohne das hiess jede Seite "AWO Care".
 *
 * Gelesen wird `data.title`, nicht Angulars `Route.title`: Die Routen dieser
 * App pflegen ihren Namen seit jeher dort, und die Navigationsleiste liest
 * ihn ebenfalls von da. Die Website macht es in ihrer SeoTitleStrategy genauso.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(state: RouterStateSnapshot): void {
    const pageTitle = deepestTitle(state.root);
    this.title.setTitle(pageTitle ? `${pageTitle} | ${BRAND}` : BRAND);
  }
}

/**
 * Name der tiefsten Route, die einen hat — Kind schlaegt Elternteil. Der
 * Rueckfall auf die Elternroute haelt Unterseiten ohne eigenen Namen
 * (Weiterleitungen, Layout-Routen) im Kontext ihres Bereichs.
 */
function deepestTitle(route: ActivatedRouteSnapshot): string | undefined {
  let found: string | undefined;
  let current: ActivatedRouteSnapshot | undefined = route;

  while (current) {
    const title = current.data['title'];
    if (typeof title === 'string' && title.length > 0) {
      found = title;
    }
    current = current.firstChild ?? undefined;
  }

  return found;
}
